import React from "react";
import { Stack, Heading, StackProps } from "@chakra-ui/react";

type BusinessEntityContentsCardProps = {
  title?: string;
  children: React.ReactNode;
} & StackProps;

const BusinessEntityContentsCard = ({
  title,
  children,
  ...props
}: BusinessEntityContentsCardProps) => {
  return (
    <Stack
      bgColor="white"
      px={{ base: 5, md: 10 }}
      pt={{ base: 5, md: 10 }}
      pb={{ base: 5, md: 8 }}
      borderRadius="8px"
      gap={0}
      {...props}
    >
      {title && (
        <Heading size={{ base: "sm", md: "md" }} mb={{ base: 4, md: 8 }}>
          {title}
        </Heading>
      )}
      {children}
    </Stack>
  );
};

export default BusinessEntityContentsCard;
